import { SET_PLUGINS_LIST } from '../types/plugins'

const initState = {
  list: [],
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_PLUGINS_LIST:
      return { ...state, list: action.payload.list }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plugins.js